const loadImage = (src: string): Promise<HTMLImageElement> => new Promise((resolve, reject) => {
  const image = new Image();
  image.onload = () => resolve(image);
  image.onerror = () => reject(new Error('Avatar image could not be loaded'));
  image.src = src;
});

const canvasToBase64 = (canvas: HTMLCanvasElement, mimeType: string): Promise<string> => new Promise((resolve, reject) => {
  canvas.toBlob(async (blob) => {
    if (!blob) {
      reject(new Error('Avatar image could not be normalized'));
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result?.toString() ?? '';
      resolve(result.split(',')[1] ?? '');
    };
    reader.onerror = () => reject(new Error('Avatar image could not be encoded'));
    reader.readAsDataURL(blob);
  }, mimeType);
});

const normalizeAvatarImage = async (
  imageData: string,
  imageType: string,
  size = 220,
): Promise<{ imageData: string; imageType: string }> => {
  const source = `data:${imageType};base64,${imageData}`;
  const image = await loadImage(source);
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;

  const context = canvas.getContext('2d');
  if (!context) throw new Error('Avatar image could not be normalized');

  const scale = Math.max(size / image.width, size / image.height);
  const drawWidth = image.width * scale;
  const drawHeight = image.height * scale;
  const offsetX = (size - drawWidth) / 2;
  const offsetY = (size - drawHeight) / 2;

  context.clearRect(0, 0, size, size);
  context.drawImage(image, offsetX, offsetY, drawWidth, drawHeight);

  const normalizedImageType = 'image/png';
  return {
    imageData: await canvasToBase64(canvas, normalizedImageType),
    imageType: normalizedImageType,
  };
};

export default normalizeAvatarImage;
